import axios from 'axios';

const getURL = (projectId: string) => `/studio/preprocessor/import/cancel/${projectId}`;

export const cancelPreProcessorImport = async (projectId: string) => {
  await axios.get(getURL(projectId));
};
